import script from "./StoreRecordStatistic.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoreRecordStatistic.vue?vue&type=script&lang=ts&setup=true"

import "./StoreRecordStatistic.vue?vue&type=style&index=0&id=eda45a40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda45a40"]])

export default __exports__